import './App.css';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Shop from './components/Shop/Shop';

function App() {
  return (
    <div>
      <Header/>
      <Shop/>
      <Footer/>
    </div>
  );
}

export default App;